export const SITE = {
  name: 'SAN Optik',
  phone: '+90 534 567 98 08',
  phoneRaw: '905345679808',
  email: 'info@sanoptik.com',
  address: 'Adalet, 1586/13. Sk. No:1C, 35530 Bayraklı/İzmir',
  hours: 'Pazartesi - Cumartesi: 09:00 - 19:30',
  hoursEn: 'Monday - Saturday: 09:00 - 7:30 PM',
  instagram: 'https://www.instagram.com/san_optikk',
  mapsUrl: 'https://www.google.com/maps/dir/?api=1&destination=38.4526326,27.1799576',
  mapsEmbed:
    'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3127.812345!2d27.1799576!3d38.4526326!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14b96343fe815a13%3A0xd44ef6d86a199e22!2sSan%20Optik!5e0!3m2!1str!2str!4v1735848291234!5m2!1str!2str',
  googleReviewsUrl: 'https://maps.app.goo.gl/zEch6UtY7GS88TLV8',
  stats: {
    brands: '27+',
    experience: '15+',
    customers: '10.000+',
  },
};

export const NAV_LINKS = [
  { path: '/', labelKey: 'nav.home' },
  { path: '/hizmetler', labelKey: 'nav.services' },
  { path: '/markalar', labelKey: 'nav.brands' },
  { path: '/magazamiz', labelKey: 'nav.store' },
  { path: '/hakkimizda', labelKey: 'nav.about' },
  { path: '/blog', labelKey: 'nav.blog' },
  { path: '/sss', labelKey: 'nav.faq' },
  { path: '/iletisim', labelKey: 'nav.contact' },
];
